
<div style="position:relative; z-index: 100; width: 100%;    ">
<nav class="navbar navbar-expand-md fixed-top py-0 top-0">
  <div class="container">
    <a class="navbar-brand " href="#"><img class="img-fluid lozad" src="assets/img/logo.png"></a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav me-auto">
      

         <li class="nav-item">
    <a class="nav-link" [routerLink]="['']">Home</a>
  </li>

  
   <li class="nav-item">
    <a class="nav-link"  href="assets/staticpages/network/index.html"
      >Network</a
    >
  </li>
   <li class="nav-item"  >
    <a class="nav-link" href="assets/staticpages/home/index.html"
      >Hub</a
    >
  </li>

  <li class="nav-item"  >
    <a class="nav-link" href="assets/staticpages/bio/index.html"
      >Bio</a
    >
  </li>
  <li class="nav-item">
          <a class="nav-link" [routerLink]="['/services']">Type of services</a>
        </li>

         <li class="nav-item">
                <a
                  class="nav-link"
                  style="white-space: nowrap"
                  [routerLink]="['/cf']"
                  >Card Features</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  style="white-space: nowrap"
                  [routerLink]="['/package']"
                  >View Services</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  style="white-space: nowrap"
                  [routerLink]="['/ai']"
                  >Additional Features</a
                >
              </li>
      </ul>
    </div>
  </div>
</nav>
</div>


<!----end navbar--->

<section id="profit">
  <div class="container">
    <div class="row">
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="non-profit" data-aos="fade-right">
          <img class="img-fluid lozad" src="assets/img/directory_images/Christians_Believe.jpg" alt="Image">
          <h3 class="text-center">Christians Believe</h3>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="non-profit" data-aos="fade-up">
          <img class="img-fluid lozad" src="assets/img/directory_images/Faith_Awards.jpg" alt="image">
          <h3 class="text-center">Faith Awards</h3>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="non-profit" data-aos="fade-left">
          <img class="img-fluid lozad" src="assets/img/directory_images/Faith_Dating.jpg" alt="Image">
          <h3 class="text-center">Faith Dating</h3>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="non-profit" data-aos="fade-right">
          <img class="img-fluid lozad" src="assets/img/directory_images/Faith_Podcast.jpg" alt="Image">
          <h3 class="text-center">Faith Podcast</h3>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="non-profit" data-aos="fade-up">
          <img class="img-fluid lozad" src="assets/img/directory_images/Faith_vs_Religion.jpg" alt="Image">
          <h3 class="text-center">Faith vs Religion</h3>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="non-profit" data-aos="fade-left">
          <img class="img-fluid lozad" src="assets/img/directory_images/Festivals.jpg" alt="Image">
          <h3 class="text-center">Festivals</h3>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="non-profit" data-aos="fade-right">
          <img class="img-fluid lozad" src="assets/img/directory_images/Praise_Concerts.jpg" alt="Image">
          <h3 class="text-center">Praise Concerts</h3>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="non-profit" data-aos="fade-up">
          <img class="img-fluid lozad" src="assets/img/directory_images/LiveStreaming.jpg" alt="Image">
          <h3 class="text-center">LiveStreaming</h3>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="non-profit" data-aos="fade-left">
          <img class="img-fluid lozad" src="assets/img/directory_images/Marketplace.png" alt="Image">
          <h3 class="text-center">Marketplace</h3>
        </div>
      </div>
    </div>
  </div>
</section>

<!---Faithhub SECTION---->

<section>
  <div class="resident  pt-5 bg-light">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-9 ps-md-0 mb-5" data-aos="flip-down">
          <div class="membership-cards">
          <div class="tribe mt-md-5 card mb-5" id="tribe">
            <h2 class="fw-bold">🙌 Welcome to Faith Hub — Where Purpose Meets Platform</h2>
            <p class="fs-4 fw-bold">
              ✝️ Welcome to the Gateway of Purpose
            </p>
            <p data-aos="fade-up">Now that you understand everything included in your digital gated community—a safe, sacred space that protects you from spiritual distractions and worldly negativity—you’ve arrived at the registration page.</p>
            
            <p data-aos="fade-up">This is where you officially register for your Faith Hub Digital Membership Card, unlocking access to an entire ecosystem of faith-driven platforms, tools, and opportunities — all under one roof.</p>

            <p data-aos="fade-up">Whether you're a ministry leader, Christian entrepreneur, gospel artist, student, or a believer ready to build and grow in faith, choose the package that aligns with your heart and budget. Once you register, you’ll gain full access to a powerful suite of tools and exclusive spaces you can enjoy, share, and grow in alongside other members of the faith-based community.</p>

            <p data-aos="fade-up">Simply select “Register” to begin the journey.</p>
            <p class="text-muted">Faith Hub is more than a platform — it’s your digital sanctuary for growth, giving, and God-ordained connection.</p>
            <strong>Join today. Empower your purpose. Build in faith.</strong>
            <p class="fs-4"><strong>For just $5.99/month, individual members receive access to:</strong></p>
            <ul class="">
              <li data-aos="fade-up">Faith-focused livestreams (sermons, devotionals, workshops)</li>
              <li data-aos="fade-up">Custom e-commerce stores for ministries, books, courses, and digital products</li>
              <li data-aos="fade-up">Secure messaging with believers, customers, and potential partners</li>
              <li data-aos="fade-up">Weekly prize giveaways, business vouchers, and scholarships</li>
              <li data-aos="fade-up">Brand-building and promotional tools to amplify your faith-based mission</li>
              <li data-aos="fade-up">Gated digital communities built for protection, privacy, and unity</li>
            </ul>
          <div class="haven" id="haven" style="display: none">

            <h3 class="fw-bold my-4" data-aos="fade-up">
              Why Faith Hub?
            </h3>
            <p>Because we believe in investing where it matters most — the Body of Christ.</p>
            <p>Each week, we support our community with:</p>
            <ul class="">
              <li data-aos="fade-up">Scholarships for students at Bible colleges, faith-based institutions, and homeschool programs</li>
              <li data-aos="fade-up">Grants for ministries and missions, supporting outreach, rent, travel, and training</li>
              <li data-aos="fade-up">Gift cards & vouchers redeemable at verified faith-based businesses</li>
              <li data-aos="fade-up">Free promotions for Christian entrepreneurs, artists, and ministry-led projects</li>
            </ul>

            <h3 class="fw-bold my-4">For Faith-Based Businesses & Sponsors</h3>

            <p data-aos="fade-up">
              <strong>Start for just $49.99/month to:</strong> 
            </p>
            <ul>
                  <li class="fw-bold">List your brand in our exclusive Faith-Based Business Directory</li>
                  <li class="fw-bold">Receive featured promotion during livestreams, giveaways, and platform-wide events</li>
                  <li class="fw-bold">Partner with ministries or influencers to expand your Kingdom impact</li>
                  <li class="fw-bold">Enjoy premium digital marketing packages that respect your message and audience</li>
                </ul>

                <h3 class="fw-bold my-4">
                  Powered by UMYO Wall Street of Technology
                </h3>
                <p>This platform is tech-powered but Spirit-led, giving you digital excellence backed by integrity. From e-commerce to livestreams, mentorship to marketing, we make it easy for believers to thrive in one trusted place.</p>
                <p>This is more than a platform — it’s a movement for Kingdom ownership, empowerment, and community-building.</p>

                <p>If you're ready to grow your ministry, promote your purpose, and connect with a powerful, faith-first network — Faith Hub is your sanctuary for digital success.</p>



            <h3 class="fw-bold my-4">
              Call to Action
            </h3>

            <p> <b>Join Faith Hub for $9.99/month<br>Launch your Christian brand or business for just $49.99</b></p>
            <p>Gain access to:</p>

                <ul>
                  <li class="fw-bold">Kingdom-minded tools</li>
                  <li class="fw-bold">Exclusive community giveaways</li>
                  <li class="fw-bold">Your own branded online presence</li>
                  <li class="fw-bold">Connection to a powerful network of believers</li>
                </ul>
                <strong>No ads. No algorithms. No noise.</strong>
                <p >Just faith, freedom, and forward movement.</p>

                <h3 class="fw-bold my-4">
                  Join the Movement
                </h3>

                 <p> <b>🔍 Explore Faith Hub<br> 🙏 Fuel the Future of Faith-Based Enterprise</b></p>

            
            <button  id="less" class="btn btn-hover-purple border-dark gap-2 mt-4" data-aos="fade-up">
            Read Less
            </button>
            </div>
            <button  id="more" class="btn btn-hover-purple border-dark gap-2 mt-4">
            Read More
            </button>
          </div>
         </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!---END Faithhub SECTION---->

<!----POWER SECTION--->
<section  class="power">
       <div class="container-fluid srice py-5">
            <div class="container py-5">
        <h1 class="text-white text-center  mb-3" style="font-weight: 600; ">Faith Hub Members </h1>
        <div class="row">
             <div class="col-lg-5 mt-5">
                <!-- <h4 class="mb-4 text-white">Search For NBA Players Connects Here</h4> -->
                
                  
                <form [formGroup]="form2" class="text-center">
            <div class="row">
              <div class="col-lg-6 mb-4">
                <input
                  type="name"
                  formControlName="selectedName"
                  class="form-control"
                  placeholder="Name"
                />
              </div>

              <!-- busnies type -->
              <div class="col-lg-6 mb-4">
                <select
                  class="form-select"
                  aria-label="Default select example"
                  formControlName="selectedBusinessType"
                >
                  <option selected value="" disabled>Business Type</option>
                  <option *ngFor="let item of businessType" [value]="item">
                    {{ item }}
                  </option>
                </select>
              </div>
              <!-- speciality type -->
              <div class="col-lg-6 mb-4">
                <select
                  class="form-select"
                  aria-label="Default select example"
                  formControlName="selectedSpecialityType"
                >
                  <option selected value="" disabled>Speciality Type</option>
                  <option *ngFor="let item of specialityType" [value]="item">
                    {{ item }}
                  </option>
                </select>
              </div>
              <div class="col-lg-6 mb-4">
                <select
                  class="form-select"
                  aria-label="Default select example"
                  formControlName="selectedYear"
                >
                  <option selected value="" disabled>Year in College</option>
                  <option *ngFor="let item of year" [value]="item">
                    {{ item }}
                  </option>
                </select>
              </div>
              <div class="col-lg-6 mb-4">
                <select
                  class="form-select"
                  aria-label="Default select example"
                  formControlName="selectedCollege"
                >
                  <option selected value="" disabled>College / University </option>
                  <option *ngFor="let item of college" [value]="item">
                    {{ item }}
                  </option>
                </select>
              </div>
              <div class="col-lg-6 mb-4">
                <select
                  class="form-select"
                  aria-label="Default select example"
                  formControlName="selectedStudy"
                >
                  <option selected value="" disabled>Study</option>
                  <option *ngFor="let item of study" [value]="item">
                    {{ item }}
                  </option>
                </select>
              </div>


              <!-- location -->
              <div class="col-lg-6 mb-4">
                <select
                  class="form-select"
                  aria-label="Default select example"
                  formControlName="selectedLocation"
                >
                  <option selected value="" disabled>Location </option>
                  <option *ngFor="let item of location" [value]="item">
                    {{ item }}
                  </option>
                </select>
              </div>

              <!-- city -->
              <div class="col-lg-6 mb-4">
                <input
                  type="text"
                  formControlName="selectedCity"
                  class="form-control"
                  placeholder="City"
                />
              </div>

              <!-- state -->
              <div class="col-lg-6 mb-4">
                <select
                  class="form-select"
                  aria-label="Default select example"
                  formControlName="selectedStateType"
                >
                  <option selected value="" disabled>State</option>
                  <option *ngFor="let item of state" [value]="item">
                    {{ item }}
                  </option>
                </select>
              </div>

              <div class="col-lg-6">
                <h4 class="mb-4 text-white text-center">
                  I PLEDGE TO REPORT VIOLENT CRIMES
                </h4>
              </div>

              <!-- race -->
              <div class="col-lg-6 mb-4">
                <select
                  class="form-select"
                  aria-label="Default select example"
                  formControlName="selectedRace"
                >
                  <option selected value="" disabled>Race</option>
                  <option *ngFor="let item of race" [value]="item">
                    {{ item }}
                  </option>
                </select>
              </div>

              <!-- gender -->
              <div class="col-lg-6 mb-4">
                <select
                  class="form-select"
                  aria-label="Default select example"
                  formControlName="selectedGender"
                >
                  <option selected value="" disabled>Gender</option>
                  <option *ngFor="let item of gender" [value]="item">
                    {{ item }}
                  </option>
                </select>
              </div>
              <div class="col-lg-6 mb-4">
                <button
                  type="submit"
                  class="btn btn-light text-white fw-semibold py-2 px-5 w-100 border-0"
                  (click)="searchCards()"
                  [disabled]="!form2.valid"
                >
                  Search
                </button>
              </div>
            </div>
          </form>

             


                
<div  class="btn-light rounded text-white py-2 px-3 my-5">
                  <p  class="text-white mb-4">Cards:</p>
                </div>
                                 <p
              class="text-white mb-4"
              style="cursor: pointer"
              [routerLink]="'/cards/share-card/' + card.id"
              *ngFor="let card of cardsSearched"
            >
              {{ card.cardTitle }}
            </p>
            </div>
            <div class="col-lg-7 mt-5">
             <div class="d-flex position-relative justify-content-center">
              <!-- Nav pills -->
             <div class="element">
                <button                           [class.active]="showLoginTab"
      (click)="checkRoute()" class="btn active">Login</button>
                <button (click)="checkRoute()"
                  [class.active]="!showLoginTab" class="btn">Register</button>
              </div>

              <!-- Tab panes -->
              <div class="tab-content rounded p-4 bg-light">
                
                <!-- Login Tab -->
<div                 [class.active]="showLoginTab" [class.inactive]="!showLoginTab"
 id="login" class="login">
                   <div class="text-center mb-5">
            <h1>Faithhub</h1>
                    <p>Register to Connect with Your Community</p>
                  </div>

                  <h2 class=" mb-3" >Login</h2>
                  <div class="row">
                                            <form [formGroup]="form">
                  <div class="row">
                   <div class="col-md-12 mb-5">
                      <div class="form-group">
                        <label style="font-size: 20px; font-weight: 600"
                          >Email
                          <sup style="color: red; font-size: 20px">*</sup>
                        </label>
                        <input
                          type="email"
                          id="email"
                          class="form-control"
                          formControlName="email"
                          required
                        />
                        <div
                          *ngIf="
                            form.get('email')?.hasError('required') &&
                            form.get('email')?.touched
                          "
                          class="text-danger"
                        >
                          Email is required.
                        </div>
                        <div
                          *ngIf="
                            form.get('email')?.hasError('email') &&
                            form.get('email')?.touched
                          "
                          class="text-danger"
                        >
                          Invalid email format.
                        </div>
                      </div>
                    </div>


                    <div class="col-md-12 mb-5">
                      <div class="form-group">
                        <label style="font-size: 20px; font-weight: 600"
                          >Password<sup style="color: red; font-size: 20px"
                            >*</sup
                          >
                        </label>
                        <input
                          type="password"
                          id="password"
                          class="form-control"
                          formControlName="password"
                          required
                        />
                        <div
                          *ngIf="
                            form.get('password')?.hasError('required') &&
                            form.get('password')?.touched
                          "
                          class="text-danger"
                        >
                          Password is required.
                        </div>
                      </div>
                      <div class="form-group" style="padding-top: 10px">
                        <label
                          style="
                            font-size: 16px;
                            font-weight: 400;
                            text-decoration: underline;
                            cursor: pointer;
                          "
                          [routerLink]="['/forgot-password']"
                          >Forgot Password?
                        </label>
                      </div>
                    </div>


                    <div class="form-check ms-3 my-3">
                      <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault">
                      <label class="form-check-label fw-bold" for="flexCheckDefault">
                        Are you above 13 years old?
                      </label>
                    </div>
                    <div class="text-center">
                      <button       (click)="openAgeModal('login')"
                                        [disabled]="!form.valid" class="btn  text-white submit py-3 px-5" >Submit</button>
                    </div>
                  </div>

</form>
                  </div>
                </div>

                <!-- Register Tab -->
  <div                 [class.active]="!showLoginTab" [class.inactive]="showLoginTab"
 id="regis" class="register" >             
 
                <form [formGroup]="form3">
                     <div class="text-center mb-5">
                       <h1>Faith Hub</h1>
                    </div>
                    <div class="row text-center mb-5">
                      <div class="col-md-3">
                        <p>Starting at</p>
                        <h1>$9.99</h1>
                        <p>Monthly</p>
                      </div>
                      <div class="col-md-1 d-none d-lg-block">
                        <div style="height: 100%; border-left: 2px solid #ccc;"></div>
                      </div>
                      <div class="col-md-6">
                        <p class="text-start">Includes:</p>
                        <ul class="text-start">
                          <li>40% off all Faith Hub products</li>
                          <li>3 free property listings per agent</li>
                          <li>Free standard CRM integrations</li>
                        </ul>
                      </div>
                    </div>

                    <h2 class=" mb-4">Register</h2>
                    <div class="row">
                       <div class="col-md-6 mb-3">
                      <div class="form-group">
                        <label style="font-size: 20px; font-weight: 600"
                          >First Name
                          <sup style="color: red; font-size: 20px"
                            >*</sup
                          ></label
                        >
                        <input
                          type="text"
                          formControlName="registerFirstName"
                          class="form-control"
                          required
                          [ngClass]="{
                            'invalid-input':
                              !form3.get('registerFirstName')?.touched &&
                              submitButtonClicked &&
                              !form3.valid
                          }"
                        />
                      </div>
                    </div>

                       <div class="col-md-6 mb-3">
                      <div class="form-group">
                        <label style="font-size: 20px; font-weight: 600"
                          >Last Name
                          <sup style="color: red; font-size: 20px">*</sup>
                        </label>
                        <input
                          type="text"
                          formControlName="registerLastName"
                          class="form-control"
                          required
                          [ngClass]="{
                            'invalid-input':
                              !form3.get('registerLastName')?.touched &&
                              submitButtonClicked &&
                              !form3.valid
                          }"
                        />
                      </div>
                    </div>

                       <div class="col-md-12 mb-3">
                      <div class="form-group">
                        <label style="font-size: 20px; font-weight: 600"
                          >Phone Number
                          <sup style="color: red; font-size: 20px"
                            >*</sup
                          ></label
                        >
                        <input
                          type="text"
                          formControlName="registerPhone"
                          class="form-control"
                          required
                          [ngClass]="{
                            'invalid-input':
                              !form3.get('registerPhone')?.touched &&
                              submitButtonClicked &&
                              !form3.valid
                          }"
                        />
                      </div>
                    </div>


                      <div class="col-md-6 mb-3">
                      <div class="form-group">
                        <label style="font-size: 20px; font-weight: 600"
                          >Email
                          <sup style="color: red; font-size: 20px"
                            >*</sup
                          ></label
                        >
                        <input
                          type="email"
                          formControlName="registerEmail"
                          class="form-control"
                          required
                          [ngClass]="{
                            'invalid-input':
                              (!form3.get('registerEmail')?.touched ||
                                !form3.get('registerEmail')?.valid) &&
                              submitButtonClicked &&
                              (!form3.valid || form3.hasError('emailMismatch'))
                          }"
                        />
                      </div>
                    </div>


                       <div class="col-md-6 mb-3">
                      <div class="form-group">
                        <label style="font-size: 20px; font-weight: 600"
                          >Confirm Email
                          <sup style="color: red; font-size: 20px"
                            >*</sup
                          ></label
                        >
                        <input
                          type="email"
                          formControlName="registerConfirmEmail"
                          class="form-control"
                          required
                          [ngClass]="{
                            'invalid-input':
                              (!form3.get('registerConfirmEmail')?.touched ||
                                !form3.get('registerConfirmEmail')?.valid) &&
                              submitButtonClicked &&
                              (!form3.valid || form3.hasError('emailMismatch'))
                          }"
                        />
                      </div>
                    </div>


                       <div class="col-md-12 mb-3">
                      <div class="form-group">
                        <label style="font-size: 20px; font-weight: 600"
                          >Password<sup style="color: red; font-size: 20px"
                            >* </sup
                          ><sup style="color: red; font-size: 14px"
                            >( Length Should be greater than 6 )</sup
                          >
                        </label>
                        <input
                          type="password"
                          class="form-control"
                          required
                          formControlName="registerPassword"
                          [ngClass]="{
                            'invalid-input':
                              (!form3.get('registerPassword')?.touched ||
                                !form3.get('registerPassword')?.valid) &&
                              submitButtonClicked &&
                              !form3.valid
                          }"
                        />
                      </div>
                    </div>


<div class="col-lg-6 mb-4">
                      <label style="font-size: 20px; font-weight: 600"
                        >Business Type<sup style="color: red; font-size: 20px"
                          >*</sup
                        >
                      </label>
                      <select
                        [ngClass]="{
                          'invalid-input':
                            (!form3.get('registerBusinessType')?.touched ||
                              !form3.get('registerBusinessType')?.valid) &&
                            submitButtonClicked &&
                            !form3.valid
                        }"
                        required
                        formControlName="registerBusinessType"
                        class="form-select"
                        aria-label="Default select example"
                      >
                        <option value="" disabled selected>
                          Please Select
                        </option>
                        <option *ngFor="let item of businessType" [value]="item">
                          {{ item }}
                        </option>
                      </select>
                    </div>


                    <!-- city -->
                    <div class="col-lg-6 mb-4">
                      <div class="form-group">
                        <label style="font-size: 20px; font-weight: 600"
                          >City
                          <sup style="color: red; font-size: 20px"
                            >*</sup
                          ></label
                        >
                        <input
                          type="text"
                          formControlName="registerCityType"
                          class="form-control"
                          required
                          [ngClass]="{
                            'invalid-input':
                              !form3.get('registerCityType')?.touched &&
                              submitButtonClicked &&
                              !form3.valid
                          }"
                        />
                      </div>
                    </div>

                    <!-- specilaity type -->
                    <div class="col-lg-6 mb-4">
                      <label style="font-size: 20px; font-weight: 600"
                        >Speciality Type<sup style="color: red; font-size: 20px">*</sup>
                      </label>
                      <select
                        [ngClass]="{
                          'invalid-input':
                            (!form3.get('registerSpecialityType')?.touched ||
                              !form3.get('registerSpecialityType')?.valid) &&
                            submitButtonClicked &&
                            !form3.valid
                        }"
                        required
                        formControlName="registerSpecialityType"
                        class="form-select"
                        aria-label="Default select example"
                      >
                        <option value="" disabled selected>
                          Please Select
                        </option>
                        <option *ngFor="let item of specialityType" [value]="item">
                          {{ item }}
                        </option>
                      </select>
                    </div>
                    <div class="col-lg-6 mb-4">
                      <label style="font-size: 20px; font-weight: 600"
                        >Year in College<sup style="color: red; font-size: 20px">*</sup>
                      </label>
                      <select
                        [ngClass]="{
                          'invalid-input':
                            (!form3.get('registerYear')?.touched ||
                              !form3.get('registerYear')?.valid) &&
                            submitButtonClicked &&
                            !form3.valid
                        }"
                        required
                        formControlName="registerYear"
                        class="form-select"
                        aria-label="Default select example"
                      >
                        <option value="" disabled selected>
                          Please Select
                        </option>
                        <option *ngFor="let item of year" [value]="item">
                          {{ item }}
                        </option>
                      </select>
                    </div>
                    <div class="col-lg-6 mb-4">
                      <label style="font-size: 20px; font-weight: 600"
                        >College / University<sup style="color: red; font-size: 20px">*</sup>
                      </label>
                      <select
                        [ngClass]="{
                          'invalid-input':
                            (!form3.get('registerCollege')?.touched ||
                              !form3.get('registerCollege')?.valid) &&
                            submitButtonClicked &&
                            !form3.valid
                        }"
                        required
                        formControlName="registerCollege"
                        class="form-select"
                        aria-label="Default select example"
                      >
                        <option value="" disabled selected>
                          Please Select
                        </option>
                        <option *ngFor="let item of college" [value]="item">
                          {{ item }}
                        </option>
                      </select>
                    </div>
                    <div class="col-lg-6 mb-4">
                      <label style="font-size: 20px; font-weight: 600"
                        >Study<sup style="color: red; font-size: 20px">*</sup>
                      </label>
                      <select
                        [ngClass]="{
                          'invalid-input':
                            (!form3.get('registerStudy')?.touched ||
                              !form3.get('registerStudy')?.valid) &&
                            submitButtonClicked &&
                            !form3.valid
                        }"
                        required
                        formControlName="registerStudy"
                        class="form-select"
                        aria-label="Default select example"
                      >
                        <option value="" disabled selected>
                          Please Select
                        </option>
                        <option *ngFor="let item of study" [value]="item">
                          {{ item }}
                        </option>
                      </select>
                    </div>

                    <!-- state -->
                    <div class="col-lg-6 mb-4">
                      <label style="font-size: 20px; font-weight: 600"
                        >State	<sup style="color: red; font-size: 20px">*</sup>
                      </label>
                      <select
                        [ngClass]="{
                          'invalid-input':
                            (!form3.get('registerStateType')?.touched ||
                              !form3.get('registerStateType')?.valid) &&
                            submitButtonClicked &&
                            !form3.valid
                        }"
                        required
                        formControlName="registerStateType"
                        class="form-select"
                        aria-label="Default select example"
                      >
                        <option value="" disabled selected>
                          Please Select
                        </option>
                        <option *ngFor="let item of state" [value]="item">
                          {{ item }}
                        </option>
                      </select>
                    </div>


                    <!-- gender -->
                    <div class="col-lg-6 mb-4">
                      <label style="font-size: 20px; font-weight: 600"
                        >Gender	<sup style="color: red; font-size: 20px">*</sup>
                      </label>
                      <select
                        formControlName="registerGenderType"
                        class="form-select"
                        aria-label="Default select example"
                        [ngClass]="{
                          'invalid-input':
                            (!form3.get('registerGenderType')?.touched ||
                              !form3.get('registerGenderType')?.valid) &&
                            submitButtonClicked &&
                            !form3.valid
                        }"
                      >
                        <option value="" disabled selected>
                          Please Select
                        </option>
                        <option *ngFor="let item of gender" [value]="item">
                          {{ item }}
                        </option>
                      </select>
                    </div>



                    <!-- location -->
                    <div class="col-lg-6 mb-4">
                      <label style="font-size: 20px; font-weight: 600"
                        >Location<sup style="color: red; font-size: 20px"
                          >*</sup
                        >
                      </label>
                      <select
                        [ngClass]="{
                          'invalid-input':
                            (!form3.get('registerLocation')?.touched ||
                              !form3.get('registerLocation')?.valid) &&
                            submitButtonClicked &&
                            !form3.valid
                        }"
                        required
                        formControlName="registerLocation"
                        class="form-select"
                        aria-label="Default select example"
                      >
                        <option value="" disabled selected>
                          Please Select
                        </option>
                        <option *ngFor="let item of location" [value]="item">
                          {{ item }}
                        </option>
                      </select>
                    </div>
                    <!-- race -->
                    <div class="col-lg-6 mb-4">
                      <label style="font-size: 20px; font-weight: 600"
                        >Race<sup style="color: red; font-size: 20px"
                          >*</sup
                        >
                      </label>
                      <select
                        [ngClass]="{
                          'invalid-input':
                            (!form3.get('registerRaceType')?.touched ||
                              !form3.get('registerRaceType')?.valid) &&
                            submitButtonClicked &&
                            !form3.valid
                        }"
                        required
                        formControlName="registerRaceType"
                        class="form-select"
                        aria-label="Default select example"
                      >
                        <option value="" disabled selected>
                          Please Select
                        </option>
                        <option *ngFor="let item of race" [value]="item">
                          {{ item }}
                        </option>
                      </select>
                    </div>

                     


                       


                      <div class="col-md-12 mb-3">
                        <label class="form-label" style="font-size: 18px;">Enter Referral Code </label>
                        <input                           formControlName="registerReferralCode"
 type="text" class="form-control" >
                      </div>
                      <div class="col-md-12 mb-3">
                        <div class="form-check ms-3 my-3">
                      <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault">
                      <label class="form-check-label fw-bold" for="flexCheckDefault">
                        Are you above 13 years old?
                      </label>
                    </div>
                      </div>
                    </div>
                    <div (click)="submitForm()" class="text-center">
                      <button      (click)="openAgeModal('signup')"
                      [disabled]="!form3.valid"
                                         type="submit" class="btn  text-white submit py-3 px-5" >Submit</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            </div>
        </div>
    </div>
  </div>
     </section>

<!---END POWER SECTION---->



<section id="profit">
  <div class="container">
    <div class="row">
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="UMYO Sports_images" data-aos="fade-right">
          <img class="img-fluid lozad" src="assets/img/directory_images/First_Work_Is_Prayer.jpg" alt="Image">
          <h3 class="text-center">First Work Is Prayer</h3>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="UMYO Sports_images" data-aos="fade-up">
          <img class="img-fluid lozad" src="assets/img/directory_images/prayer.jpg" alt="Image">
          <h3 class="text-center">Prayer</h3>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="UMYO Sports_images" data-aos="fade-left">
          <img class="img-fluid lozad" src="assets/img/directory_images/Prayer_For_Our_Country.jpg" alt="Image">
          <h3 class="text-center">Prayer For Our Country</h3>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="UMYO Sports_images" data-aos="fade-right">
          <img class="img-fluid lozad" src="assets/img/directory_images/Ramadan.jpg" alt="Image">
          <h3 class="text-center">Ramadan</h3>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="UMYO Sports_images  " data-aos="fade-up" >
          <img class="img-fluid lozad w-auto mx-auto d-block" src="assets/img/directory_images/The_Word_Of_God.jpg" alt="Image">
          <h3 class="text-center">The Word Of God</h3>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="UMYO Sports_images  " data-aos="fade-left" style="width: fit-content;">
          <img class="img-fluid lozad w-auto mx-auto d-block" src="assets/img/directory_images/World_Unity.jpg" alt="Image">
          <h3 class="text-center">World Unity</h3>
        </div>
      </div>

    </div>
  </div>
</section>

<!----END CARDS SECTION--->

<footer>
  <div class="container">
    <h3>Join Faith Hub. Share your mission. Uplift your audience. Grow with purpose.</h3>
    <h6>This is more than a platform — it’s a movement for Kingdom ownership, empowerment, and community-building.</h6>
  </div>
</footer>




<div
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngClass]="{ show: showPackageModal, 'd-block': showPackageModal }"
  style="background-color: rgb(0, 0, 0, 0.8)"
>
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">
          Select One Package
        </h5>
        <button type="button" class="close"  style="padding-left:10px;padding-right:10px"(click)="closePackageModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" style="max-height: 70vh; overflow-y: scroll">
        <div class="row">
          <div class="col-md-6" *ngFor="let package of packages; let i = index">
            <div class="outerCard" style="min-height: 30vh; cursor: pointer">
              <div
                class="card"
                [ngClass]="{ cardSelect: selectedPackage === package }"
                (click)="selectPackage(package)"
              >
                <div class="card-body">
                  <h5 class="card-title" style="color: rgb(35, 149, 243)">
                    $
                    {{ package.net_price ? package.net_price : package.price }}
                    <sup
                      style="
                        text-decoration: line-through;
                        font-size: 20px;
                        color: gray;
                        padding-left: 15px;
                      "
                      *ngIf="package.net_price"
                      >{{ package.price }}</sup
                    >
                  </h5>
                  <p class="card-text">Cards Limit: {{ package.limit }}</p>
                  <p class="card-duration">Duration: {{ package.expire_in }}</p>

                  <div
                    class="description-container"
                    style="max-height: 100px; overflow-y: auto"
                  >
                    <p class="card-description">{{ package.description }}</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="w-100" *ngIf="(i + 1) % 2 === 0"></div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button
          (click)="closePackageModal()"
          type="button"
          class="btn btn-secondary"
        >
          Close
        </button>

        <div
          *ngIf="selectedPackage?.price != '0'"
          [ngClass]="{
            hidden: selectedPackage == null || selectedPackage?.price == '0',
            paymentButtons: selectedPackage != null
          }"
        >
          <!-- <div id="paypal-button-container"></div> -->
          <!-- hide stripe  -->
          <!-- <button
            type="button"
            style="background-color: rgb(35, 149, 243); color: white"
            class="btn btn-info"
            (click)="openStripeModal()"
          >
            Stripe
          </button> -->
          <button
            type="button"
            style="background-color: rgb(35, 149, 243); color: white"
            class="btn btn-info"
            (click)="paypalClick()"
          >
            paypal
          </button>
        </div>
        <div *ngIf="selectedPackage?.price == '0'">
          <button
            type="button"
            style="background-color: rgb(35, 149, 243); color: white"
            class="btn btn-info"
            (click)="continuePaymentButton()"
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngClass]="{ show: showLoadingModal, 'd-block': showLoadingModal }"
  style="background-color: rgb(0, 0, 0, 0.8)"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <div class="container">
          <h3>{{ paypalTitleMessage }}</h3>
          <p style="padding-top: 15px">{{ paypalMessage }}</p>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- stripe modal  -->

<div
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngClass]="{ show: showStripeModal, 'd-block': showStripeModal }"
  style="background-color: rgb(0, 0, 0, 0.8)"
>
  <div class="modal-dialog modal-dialog-centered modal-md" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">
          Pay Through Stripe
        </h5>
        <button type="button" class="close"  style="padding-left:10px;padding-right:10px"(click)="closeStripeModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="container">
          <form class="checkout-form" [formGroup]="paymentForm">
            <h3>
              Amount
              {{
                selectedPackage?.net_price
                  ? selectedPackage?.net_price
                  : selectedPackage?.price
              }}
            </h3>
            <div class="row">
              <div class="col-md-12" style="padding-top: 17px">
                <div class="form-group">
                  <label
                    for="card-number"
                    style="
                      font-size: 17px;
                      font-weight: 600;
                      padding-bottom: 8px;
                    "
                    >Card Number 16 Digit (Without Dashes)</label
                  >
                  <input
                    type="text"
                    class="form-control"
                    id="card-number"
                    data-stripe-element="cardNumber"
                    formControlName="cardNumber"
                    placeholder="XXXXXXXXXXXXXXXX"
                  />
                </div>
              </div>
              <div class="col-md-12" style="padding-top: 17px">
                <div class="form-group">
                  <label
                    for="card-expiry"
                    style="
                      font-size: 17px;
                      font-weight: 600;
                      padding-bottom: 8px;
                    "
                    >Expiration Date in (MM/YY) Format including /
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="card-expiry"
                    data-stripe-element="expiryDate"
                    formControlName="expiryDate"
                    placeholder="MM/YY"
                  />
                </div>
              </div>
              <div class="col-md-12" style="padding-top: 17px">
                <div class="form-group">
                  <label
                    for="card-cvc"
                    style="
                      font-size: 17px;
                      font-weight: 600;
                      padding-bottom: 8px;
                    "
                    >CVC 3 Digit</label
                  >
                  <input
                    type="text"
                    class="form-control"
                    id="card-cvc"
                    data-stripe-element="cvc"
                    formControlName="cvc"
                    placeholder="XXX"
                  />
                </div>
              </div>
            </div>

            <div class="row mt-3">
              <div
                class="col-md-12"
                style="
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  padding-top: 10px;
                "
              >
                <button
                  type="submit"
                  class="btn btn-primary"
                  data-bs-toggle="modal"
                  id="pay-button"
                  (click)="pay()"
                >
                  Pay Now
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          (click)="closeStripeModal()"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngClass]="{ show: showAgeModal, 'd-block': showAgeModal }"
  style="background-color: rgb(0, 0, 0, 0.8)"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <div class="container">
          <h3>Are You 18+ of your age?</h3>
        </div>
        <p style="padding: 8px">
          You must be at least 13 years old to use the Service. However,
          children of all ages may use the Service and PLTalk Kids (where
          available) if enabled by a parent or legal guardian. Permission by
          Parent or Guardian If you are under 18, you represent that you have
          your parent or guardian’s permission to use the Service. Please have
          them read this Agreement with you. If you are a parent or legal
          guardian of a user under the age of 18, by allowing your child to use
          the Service, you are subject to the terms of this Agreement and
          responsible for your child’s activity on the Service. You can find
          tools and resources to help you manage your family’s experience on
          PLTalk in our Help Center
        </p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="confirmAge()">
          Yes
        </button>
        <button
          type="button"
          class="btn btn-secondary"
          (click)="closeAgeModal()"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</div>
